import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Modal from 'react-modal';
import { BaseURL, uniqueToken, BaseSocketURL } from '../../api/DataApis';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import Loader from '../Chargers/Loader';

const LiveData = () => {
  document.title = "  Evtor || Live-Pings";
  const [OCPPData, setOCPPData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ChargerData, setChargerData] = useState([]);
  const [selectedchargerEmi, setSelectedChargerEmi] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [Message, setMessage] = useState('');
  const [connectorIDValue, setConnectorIDValue] = useState('');
  const [IDtag, setIDTag] = useState('');
  const [transactionID, setTransactionID] = useState('');
  const [socket, setSocket] = useState(null);
  const [connectorListing, setconnectorListing] = useState([]);
  const [ master_connector_id, setMasterConnectorId ] = useState("");
  const [selectedConnectorID, setSelectedConnectorID] = useState('');
  const [selectedBookingID, setSelectedBookingID] = useState('');

  const navigate = useNavigate();

  // Generate Random Number
  const generateRandomNumber = () => Math.floor(10000000 + Math.random() * 90000000);

  const options = ChargerData?.map((item) => ({
    value: item.imei_number,
    label: item.imei_number,
  }));

  //const handleChargerEmiChange = (e) => setSelectedChargerEmi(e.target.value);
 const handleChargerEmiChange = (selectedOption) => {
    setSelectedChargerEmi(selectedOption); // Store the entire selected option if needed
    setOCPPData([]); // Clear the logs when a new charger is selected
  };
        
  const handlebookingNumber = (e) => {
    setSelectedBookingID(e.target.value.trim());
  }

  const handleTransactionIDChange = (e) => setTransactionID(e.target.value);

  const handleMessageChange = (e) => setMessage(e.target.value);

  const handleConnectorIDChange = (e) => setConnectorIDValue(e.target.value);

  const handleIDTagChange = (e) => setIDTag(e.target.value);

  const fetchChargers = async () => {
    setLoading(true);
    const apiEndpoint = `${BaseURL}/chargers`;

    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      setChargerData(response?.data?.data?.data || []);
    } catch (error) {
      console.error("Error fetching ChargerData:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchConnectors = async () => {
    setLoading(true);
    
    const apiUrl = `${BaseURL}/master/dc-0`;

    try {
        const response = await axios.get(apiUrl, {
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: `Bearer ${uniqueToken}`,
            },
        });
        console.log("response", response);
        setconnectorListing(response?.data?.data || []);
      
    } catch (error) {
        console.error("Error fetching users:", error);
    } finally {
        setLoading(false);
    }
  };

  useEffect(() => {
    fetchConnectors();
  }, []);

  const fetchOcppData = async () => {
    setLoading(true);
    const apiEndpoint = `${BaseURL}/occpLog`;
    const queryParams = selectedchargerEmi ? `?charger_emi=${selectedchargerEmi}` : '';

    try {
      const response = await axios.get(`${apiEndpoint}${queryParams}`, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      setOCPPData(response.data || []);
    } catch (error) {
      console.error("Error fetching OCPP data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChargers();
    //fetchOcppData();
  }, [selectedchargerEmi]);

  useEffect(() => {
    // Set the WebSocket URL conditionally
    const socketUrl = `${BaseSocketURL}/evtor?secret=evtorwebsocket@2024`;
    
  
    // Create a new WebSocket instance with the determined URL
    const newSocket = new WebSocket(socketUrl);
  
    newSocket.onopen = () => {
      console.log("WebSocket connection opened.");
    };
  
    newSocket.onmessage = (event) => {
      const response = JSON.parse(event.data);
      console.log("Received WebSocket response:", response);
  
      const currentDate = new Date();
      const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}-${currentDate.toLocaleString('default', { month: 'short' })}-${currentDate.getFullYear()} ${currentDate.getHours()}:${currentDate.getMinutes().toString().padStart(2, '0')}:${currentDate.getSeconds().toString().padStart(2, '0')} ${currentDate.getHours() >= 12 ? 'PM' : 'AM'}`;
  
      const requestResponseObj = {
        charger_emi: selectedchargerEmi,
        request: modalContent,
        response,
        createdAt: formattedDate,
      };
  
      setOCPPData((prevData) => [requestResponseObj, ...prevData]);
    };
  
    newSocket.onerror = (error) => {
      console.error("WebSocket error:", error);
      // Swal.fire({
      //   icon: "error",
      //   title: "Error",
      //   text: "An error occurred with the WebSocket connection.",
      // });
    };
  
    newSocket.onclose = () => {
      console.log("WebSocket connection closed.");
    };
  
    // Set the socket state to manage WebSocket connection
    setSocket(newSocket);
  
    // Cleanup function to close WebSocket on component unmount
    return () => {
      newSocket.close();
    };
  }, [selectedchargerEmi]);  // Re-run when selectedchargerEmi changes
  

  const openModal = (content) => {
    setModalContent(content);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setModalContent('');
  };

  const filteredData = OCPPData.filter((ocpp) => {
    const matchesChargerEmi = selectedchargerEmi?.value
      ? ocpp?.response?.IMEI?.toString().replace(/^"|"$/g, "").trim().includes(selectedchargerEmi.value.trim())
      : true; // If no charger EMI is selected, include all
  
    const matchesBookingId = selectedBookingID
      ? ocpp?.response?.B?.toString().trim().includes(selectedBookingID)
      : true; // If no booking ID is entered, include all
  
    return matchesChargerEmi && matchesBookingId;
  }); // If no charger is selected, show all data


  console.log("Selected Charger IMEI:", selectedchargerEmi?.value);


  console.log("filteredDataaaaaaa", filteredData);
  console.log("ocppData", OCPPData);
  


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare the request based on modal content
    const randomNumber = generateRandomNumber();
    let request;

    if (modalContent === "TriggerMessage") {
      request = [2, randomNumber, modalContent, { "requestedMessage": Message, "connectorId": selectedConnectorID }];
    } else if (modalContent === "RemoteStartTransaction") {
      request = [2, randomNumber, modalContent, { "connectorId": selectedConnectorID, "idTag": IDtag }];
    } else if (modalContent === "RemoteStopTransaction") {
      request = [2, randomNumber, modalContent, { "transactionId": transactionID }];
    } else {
      request = [2, randomNumber, "ChangeAvailability", { "type": Message }];
    }

    // Send WebSocket request
    if (socket && socket.readyState === WebSocket.OPEN) {

      const currentDate = new Date();
      const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}-${currentDate.toLocaleString('default', { month: 'short' })}-${currentDate.getFullYear()} ${currentDate.getHours()}:${currentDate.getMinutes().toString().padStart(2, '0')}:${currentDate.getSeconds().toString().padStart(2, '0')} ${currentDate.getHours() >= 12 ? 'PM' : 'AM'}`;

      const requestResponseObj = {
        charger_emi: selectedchargerEmi,
        //request: modalContent,
        response:request,
        createdAt: formattedDate,
      };

      setOCPPData(prevData => [requestResponseObj, ...prevData]);

      socket.send(JSON.stringify(request));
      closeModal();
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "WebSocket connection is not open. Please try again.",
      });
    }
  };
  const handleConnectorID = (e)=> {
  
    setMasterConnectorId(e.target.value);
    const connectorId = e.target.selectedOptions[0].getAttribute('connectorId');
    console.log("e.target.value", e.target.value, "connectorIdDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD", connectorId );
    setSelectedConnectorID(connectorId);
  }
console.log("selectedchargerEmi.....", selectedchargerEmi);

  return (
    <div className='container-fluid' style={{ minHeight: '100vh' }}>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
              <div className="d-flex justify-content-between align-items-center">
                <h4>Live Data</h4>
              </div>
              <hr style={{ marginTop: "5px" }} />

              <div className="row">
              <div className= "col-md-12">
                  <div className="card-body">
                  <div className="col-12 col-md-4 mb-3 d-flex justify-content-start align-items-center gap-3">
  <Select
    options={options}
    value={selectedchargerEmi}
    onChange={handleChargerEmiChange}
    placeholder="Select Charger"
    className="w-100"
    isClearable
  />
  <input
    type="text"
    placeholder="Search Booking ID"
    className="form-control w-100"
    onChange={handlebookingNumber} // Define this function in your code
  />
</div>


       
                    <div className="table-responsive">
                      <table className="display dataTable" id="advance-1" >
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Charger EMI</th>
                            <th>Request & Response</th>
                            <th>Created Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredData.length > 0 ? (
                            filteredData.map((ocpp, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td style={{ textAlign: 'center' }}>
                  {ocpp?.response?.IMEI ? ocpp?.response?.IMEI.toString().replace(/^"|"$/g, '') : ''}
                </td>
                                <td><pre>{JSON.stringify(ocpp?.response, null, 2)}</pre></td>
                                <td>{ocpp.createdAt}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center"><h4>No Data Found</h4></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Command Modal"
        ariaHideApp={false}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '50%',
          },
        }}
      >
        <h2>{modalContent}</h2>
        <form onSubmit={handleSubmit}>
          {modalContent === 'TriggerMessage' && (
            <>
              <div className="form-group">
                <label>Message</label>
                <select className="form-control" onChange={handleMessageChange}>
                  <option value="">Select Message</option>
                  <option value="BootNotification">BootNotification</option>
                  <option value="DiagnosticsStatusNotification">DiagnosticsStatusNotification</option>
                  <option value="FirmwareStatusNotification">FirmwareStatusNotification</option>
                  <option value="Heartbeat">Heartbeat</option>
                  <option value="MeterValues">MeterValues</option>
                  <option value="StatusNotification">StatusNotification</option>
                </select>
              </div>
              <div className="form-group">
                <label>Connector ID</label>
                <select className="form-control"  onChange={handleConnectorID} required >
                <option>Select Option</option>
      {connectorListing?.map((user) => (
    <option 
      key={user?._id} 
      value={user?._id} 
      connectorId={user?.connectorId}
    
    >
      {user?.title}
    </option>
  ))}
                  </select>
                
              </div>
            </>
          )}

          {modalContent === 'RemoteStartTransaction' && (
            <>
              <div className="form-group">
                <label>ID Tag</label>
                <input type="text" className="form-control" value={IDtag} onChange={handleIDTagChange} required />
              </div>
              <div className="form-group">
                <label>Connector ID</label>
                <select className="form-control"  onChange={handleConnectorID} required >
                <option>Select Option</option>
      {connectorListing?.map((user) => (
    <option 
      key={user?._id} 
      value={user?._id} 
      connectorId={user?.connectorId}
    
    >
      {user?.title}
    </option>
  ))}
                  </select>
              </div>
            </>
          )}

          {modalContent === 'RemoteStopTransaction' && (
            <div className="form-group">
              <label>Transaction ID</label>
              <input type="text" className="form-control" value={transactionID} onChange={handleTransactionIDChange} required />
            </div>
          )}

          {modalContent === 'ChangeAvailability' && (
            <div className="form-group">
              <label>Message</label>
              <select className="form-control" onChange={handleMessageChange}>
                <option value="">Select Message</option>
                <option value="Hard">Hard</option>
                <option value="Soft">Soft</option>
              </select>
            </div>
          )}

          <button type="submit" className="btn btn-primary">Submit</button>
          <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
        </form>
      </Modal>
    </div>
  );
};

export default LiveData;
